"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CompletedOn;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _getCompletionDate = _interopRequireDefault(require("../utils/getCompletionDate"));

var _isPendingReview = _interopRequireDefault(require("../utils/isPendingReview"));

var _isFailedContent = _interopRequireDefault(require("../utils/isFailedContent"));

var _Separator = _interopRequireDefault(require("../components/Separator"));

var s = {
  root: function root(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-family:ChronicaPro;font-size:", isMobile ? '12px' : '14px', ";margin-right:2px;color:", theme.color.dark.iron, ";line-height:1;", isMobile &&
      /*#__PURE__*/
      (0, _emotion.css)("margin-top:10px;"), ";")
    );
  },
  failedContent: function failedContent(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-family:ChronicaPro;font-size:", isMobile ? '12px' : '14px', ";margin-right:2px;color:", theme.color.dark.ruby, ";line-height:1;", isMobile &&
      /*#__PURE__*/
      (0, _emotion.css)("margin-top:10px;"), ";")
    );
  },
  pendingReview: function pendingReview(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-family:ChronicaPro;font-size:", isMobile ? '12px' : '14px', ";font-weight:500;font-stretch:normal;font-style:normal;line-height:1;letter-spacing:normal;margin-left:4px;margin-bottom:1px;color:", theme.color.dark.topaz, ";", isMobile &&
      /*#__PURE__*/
      (0, _emotion.css)("margin-top:10px;"), ";")
    );
  }
};

function CompletedOn(props) {
  var theme = props.theme,
      isMobile = props.isMobile,
      separatorClassName = props.separatorClassName,
      customClassName = props.customClassName;
  var completionDate = (0, _getCompletionDate.default)(props);

  if (!completionDate) {
    return null;
  }

  var formattedCompletedOn = (0, _format.default)(completionDate, 'Do MMM');
  var pendingReview = (0, _isPendingReview.default)(props);
  var isFailed = (0, _isFailedContent.default)(props);

  if (props.type === 'Wide') {
    return _react.default.createElement(_react.default.Fragment, null, isFailed ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: (0, _classnames.default)(s.failedContent(theme, isMobile), customClassName)
    }, "Failed"), _react.default.createElement(_Separator.default, {
      key: "pendingReview",
      className: separatorClassName
    })) : null, pendingReview ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: (0, _classnames.default)(s.pendingReview(theme), customClassName)
    }, "Pending Review"), _react.default.createElement(_Separator.default, {
      key: "pendingReview",
      className: separatorClassName
    })) : null, _react.default.createElement("div", {
      className: (0, _classnames.default)(s.root(theme, isMobile), customClassName)
    }, "Completed on ", formattedCompletedOn));
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: (0, _classnames.default)(s.root(theme, isMobile), customClassName)
  }, "Completed on ", formattedCompletedOn), isFailed ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Separator.default, {
    key: "pendingReview",
    className: separatorClassName
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(s.failedContent(theme, isMobile), customClassName)
  }, "Failed")) : null, pendingReview ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Separator.default, {
    key: "pendingReview",
    className: separatorClassName
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(s.pendingReview(theme, isMobile), customClassName)
  }, "Pending Review")) : null);
}